import { secondAxios } from "../../../../../api/axios";

export const updateCO = async (id, row) => {
  const res = await secondAxios.patch(`/change-order/${id}`, row);
  console.log({ res });

  return res;
};
